import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Notepad = ({
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE,
  className = 'w-4 h-4'
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <path
        d='M14 2v6h6M16 13H8M16 17H8M10 9H8'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
};

export default Notepad;
